<template>
  <span class="leading-none" :style="statusConfig.style">
    {{ statusConfig.label }}
  </span>
</template>

<script>
import { SurveyStatus } from '@/api/v2/requests/surveys';
import { surveyStatusStyles } from '@/views/Brand/Surveys/_constants/survey-status';

export default {
  name: 'SurveyStatusBadge',
  props: {
    status: {
      type: String,
      required: false,
      validator: (value) =>
        !value || Object.values(SurveyStatus).includes(value),
    },
  },
  computed: {
    statusConfig() {
      const status = this.status || this.params?.status;
      const baseStyle = surveyStatusStyles[status] || {};

      const customStyle = this.params?.style || {};
      const style = { ...baseStyle, ...customStyle };

      const label = this.$t(`survey-status.${status}`);

      return {
        style,
        label,
      };
    },
  },
};
</script>
